"use strict";

const AssetsAssetsEsriDynamicMapLayer = function () {
  const layerName = "assetsAssetsEsriDynamicMap";
  const layerKey = "assetsAssetsEsriDynamicMapLayer";
  const esriKey = "assets";
  const esriLayer = "bmp";

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    var assetsAssetsEsriDynamicMapLayer = new EsriDynamicMapLayer(
      layerName,
      layerKey,
      esriKey,
      esriLayer,
    );
    assetsAssetsEsriDynamicMapLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    assetsAssetsEsriDynamicMapLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };
  var loadLayer = function () {};

  return {
    loadLayerListenersForMap,
    loadLayer,
  };
};

module.exports = AssetsAssetsEsriDynamicMapLayer();

const EsriDynamicMapLayer = require("../mapFunctions/esriDynamicMapLayer");
